import { useState } from 'react';

import {
    Align,
    Button,
    ButtonList,
    ButtonVariant,
    Icon,
    IconName,
    Modal,
    ModalBody,
    ModalFooter,
    Text,
    TextLevels,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

type EditAddressProps = {
    address: string[];
    onResetAddress?: () => void;
};

export function EditAddress({ address, onResetAddress }: Readonly<EditAddressProps>) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleResetAddress = () => {
        onResetAddress?.();
        setIsModalOpen(false);
    };

    return (
        <>
            <View flexable className='gap-medium is-justified-center-tablet' align={Align.CENTER}>
                <Icon name={IconName.MARKER} />
                <Text
                    level={TextLevels.TWO}
                    typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                    marginless
                    data-cy='results-address'
                >
                    {address.join(' ')}
                </Text>
                <button
                    className='link button-clear'
                    aria-label="Relancer le test d'éligibilité pour une nouvelle adresse"
                    onClick={() => setIsModalOpen(true)}
                    data-cy='results-address'
                >
                    Modifier
                </button>
            </View>
            <Modal
                active={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={'On teste une nouvelle adresse&nbsp;?'}
            >
                <ModalBody className='has-text-centered'>
                    {address.map((line) => (
                        <Text key={line}>{line}</Text>
                    ))}
                </ModalBody>
                <ModalFooter>
                    <ButtonList className='!is-fullwidth' align={Align.CENTER}>
                        <Button variant={ButtonVariant.PRIMARY} onClick={handleResetAddress}>
                            Oui
                        </Button>
                        <Button variant={ButtonVariant.PRIMARY} onClick={() => setIsModalOpen(false)}>
                            Non
                        </Button>
                    </ButtonList>
                </ModalFooter>
            </Modal>
        </>
    );
}
